module.exports = __webpack_public_path__ + "static/media/login-left2x.ca48dbd5.png";